import { Level } from "iq-questions/types";

const difficultyConfig: Record<Level, { color: string; bg: string }> = {
  1: { color: "#16a34a", bg: "#f0fdf4" },
  2: { color: "#d97706", bg: "#fffbeb" },
  3: { color: "#dc2626", bg: "#fef2f2" },
};

const difficultyLabels: Record<Level, string> = {
  1: "Easy",
  2: "Medium",
  3: "Hard",
};

const difficultyLabel = (level: Level) => difficultyLabels[level];

function LevelPillTag({ level }: { level: Level }) {
  const { color, bg } = difficultyConfig[level];
  return (
    <span
      className="text-xs font-semibold px-2.5 py-1 rounded w-fit"
      style={{ color, backgroundColor: bg }}
    >
      {difficultyLabel(level)}
    </span>
  );
}

export { LevelPillTag, difficultyConfig, difficultyLabel };
